import { Component } from '@angular/core';
import {AsyncPipe, DatePipe, NgIf} from "@angular/common";
import {CardComponent} from "../../components/ui/card/card.component";
import {DetailEntryFieldComponent} from "../../components/ui/detail-entry-field/detail-entry-field.component";
import {TranslateModule} from "@ngx-translate/core";
import {map} from "rxjs";
import {ActivatedRoute} from "@angular/router";
import {TagIconPreviewPipe} from "../../pipes/tag-icon-preview.pipe";

@Component({
  selector: 'app-tag-detail-info',
  standalone: true,
  imports: [
    AsyncPipe,
    CardComponent,
    DatePipe,
    DetailEntryFieldComponent,
    TranslateModule,
    TagIconPreviewPipe,
    NgIf
  ],
  templateUrl: './tag-detail-info.component.html',
  styleUrl: './tag-detail-info.component.scss'
})
export class TagDetailInfoComponent {
  tag$ = this.route.parent!.data.pipe(map(data => data['tag']));

  constructor(private route: ActivatedRoute) {
  }
}
